
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundMutedFill as ObiSoundMutedFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-muted-fill.js';
 
 
 

 
 export const ObiSoundMutedFill = createComponent({
   react: React,
   tagName: 'obi-sound-muted-fill',
   elementClass: ObiSoundMutedFillElement,
   events: {
     
   }
  });
 
 